export default __webpack_public_path__ + "static/media/banner.d9efc2a9.png";